module.exports = __webpack_public_path__ + "media/images/custom_page/younite_event5/younite-event-ko-0f946a41e05fdb144c734c8e08b662aa.png";